import Divider from "@mui/material/Divider";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
import patientLandingImage from "../Media/patient-landing.png";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { HXMobileButton } from "./HXButton";
import { FooterText } from "./PatientConsentManagerShared.styles";
export const TopSpacer = styled.div `
    height: 24px;
`;
export const Explanation = styled.div `
    color: ${colors.black_light};
    line-height: normal;
    white-space: pre-wrap;
`;
export const ShorterExplanation = styled(Explanation) `
    margin-top: 40px;
    white-space: pre-wrap;
`;
export const ErrorMessage = styled.div `
    font-size: ${fontSizes.MEDIUM};
    color: ${colors.tulip_main};
`;
export const PatientLandingImage = styled.div `
    background-image: url(${patientLandingImage});
    background-repeat: no-repeat;
    background-size: cover;
    height: ${(props) => props.height}px;
    width: 100%;
    flex-shrink: 0;
`;
export const RowContainer = styled(FlexRowDiv) `
    justify-content: space-around;
    align-items: center;
    align-self: stretch;
    gap: 8px;
`;
export const RowDivider = styled(Divider) `
    flex: 1;
`;
export const RowIcon = styled.img `
    width: 24px;
    height: 24px;
`;
export const RowStartIconAndNameContainer = styled(FlexRowDiv) `
    display: flex;
    align-items: center;
    gap: 8px;
    line-height: normal;
`;
export const ClearTextContainer = styled(FlexColumnDiv) `
    gap: 12px;
    padding-bottom: 8px;
`;
export const AnotherProvider = styled(HXMobileButton) `
    justify-content: center;
    line-height: normal;
    padding-top: 6px;
    padding-bottom: 6px;
`;
export const TermsText = styled(FooterText) `
    padding-bottom: 30px;
    white-space: pre-wrap;
`;
